import { useQuery } from '@tanstack/react-query';

import { statsService } from '@/services/stats.service';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Jumlah pendaftaran dari sipaud.com yang menunggu persetujuan.
 *
 * Dipakai sidebar untuk memberi tanda pada menu Kelola Tenant. Angkanya ada
 * gunanya justru karena terlihat dari halaman mana pun: pendaftaran mandiri
 * tidak mengirim surel apa pun ke siapa pun (sistem ini belum punya layanan
 * surel), jadi tanpa penanda yang mengikuti ke setiap layar, satu-satunya cara
 * mengetahuinya adalah membuka dashboard dan sengaja mencarinya.
 *
 * Memakai query yang sama dengan Dashboard Platform sehingga keduanya berbagi
 * satu jawaban, bukan dua permintaan yang berjalan berdampingan.
 */
export function usePendingRegistrationCount(): number {
  // Digantungkan pada izinnya, bukan pada perannya: angkanya datang dari
  // ringkasan platform, dan siapa pun yang boleh membacanya boleh melihat
  // penanda ini. Marketing tidak termasuk — ia melihat pendaftar lewat
  // saringan status di halaman Kelola Tenant.
  const canReadStats = useAuthStore((state) => state.hasPermission('platformStats.read'));

  const { data } = useQuery({
    queryKey: ['platform-stats'],
    queryFn: () => statsService.getPlatformStats(),
    enabled: canReadStats,
    // Pendaftaran datang kapan saja; sekali beberapa menit sudah cukup cepat
    // untuk sesuatu yang ditindaklanjuti manusia.
    staleTime: 60_000,
    refetchInterval: 5 * 60_000,
    retry: false,
  });

  return data?.tenants.pending ?? 0;
}
